
import { fetchWithAuth } from "./fetchWithAuth";
import { addNotification } from "./store";

export const ROOT = process.env.REACT_APP_API_ORIGIN || 'http://localhost:8080/'
export const API_ROOT = ROOT + 'api/v1/'
// export const ROOT = 'https://api.surftms.com/'
// export const API_ROOT = 'https://api.surftms.com/api/v1/'
export function sendRequest(method, link,  signal, postSuccessAction, postErrorAction, body, customContentType, preSendManipulation, notJsonResponse, customComapnyId, customTenatnId){    
    
    link = encodeURI(link);
    switch (method) {
        case 'GET':
            sendGetRequest(link, signal, postSuccessAction, postErrorAction, customComapnyId, customTenatnId, notJsonResponse);
            break;
        case 'POST':
            sendPostRequest(link, postSuccessAction, postErrorAction, body, customContentType, preSendManipulation, notJsonResponse);
            break;
        case 'PATCH':
            sendPatchRequest(link, postSuccessAction, postErrorAction, body, customContentType, preSendManipulation)
            break;
        case 'PUT':
            sendPutRequest(link, postSuccessAction, postErrorAction, body, customContentType, preSendManipulation)
            break;
        case 'DELETE':
            sendDeleteRequest(link, signal, postSuccessAction, postErrorAction, customComapnyId);
            break;
        default:
            break;
    }
}

function resolveCompanyId(customComapnyId) {
    let companyId = customComapnyId != null
        ? parseInt(customComapnyId, 10)
        : parseInt(localStorage.getItem("currentCompanyId"), 10);
    if (!companyId || isNaN(companyId)) {
        const container = document.getElementById("currentCompanyNameContainer");
        if (container) {
            companyId = parseInt(container.getAttribute('data-company-id'), 10);
            if (!isNaN(companyId)) {
                localStorage.setItem("currentCompanyId", companyId);
            }
        }
    }
    return companyId;
}

function getAuthHeaders(customContentType, customComapnyId) {
    // Always resolve companyId at request time. Form configs often snapshot
    // parseInt(localStorage...) at module load, which yields NaN before login.
    const companyId = resolveCompanyId(customComapnyId);
    if (customContentType) {
        const headers = typeof customContentType === 'function'
            ? customContentType()
            : { ...customContentType };
        const provided = headers.companyId != null ? Number(headers.companyId) : NaN;
        if (!provided || isNaN(provided)) {
            headers.companyId = companyId;
        }
        return headers;
    }
    return {
        "Content-Type": "application/json",
        "companyId": companyId,
    };
}

function sendGetRequest(Link, signal, postResultAction, postErrorAction, customComapnyId, customTenatnId, notJsonResponse){
    
    fetchWithAuth(Link, customTenatnId,
        {
            signal: signal,
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: "cors", // no-cors, *cors, same-origin
            // cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            // credentials: "include", // include, *same-origin, omit
            headers: getAuthHeaders(null, customComapnyId, customTenatnId), // Use getAuthHeaders
        })
        .then((response) => {
            return status(response, postErrorAction)
        })
        .then((response) => notJsonResponse ? response : response.json())
        .then((response) => {
            postResultAction(response);
        })
        .catch(() => {
            
        });
}

function sendPostRequest(Link, postResultAction, postErrorAction, body, customContentType, preSendManipulation, notJsonResponse){
    fetchWithAuth(Link, null,
        {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            // mode: "cors", // no-cors, *cors, same-origin
            // cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            // credentials: "include", // include, *same-origin, omit
            headers: getAuthHeaders(customContentType, null), // Use getAuthHeaders
            body: preSendManipulation ? preSendManipulation(body) : JSON.stringify(body)
        })
        .then((response) => {
            return status(response, postErrorAction)
        })
        .then((response) => { return notJsonResponse? response : response.json();
        }).then((response) => {
            postResultAction(response);
        })
        .catch(() => {
            
        });
}
function sendPutRequest(Link, postResultAction, postErrorAction, body, customContentType, preSendManipulation){
    fetchWithAuth(Link, null,
        {
            method: 'PUT',
            headers: getAuthHeaders(customContentType, null),
            body: preSendManipulation ? preSendManipulation(body) : JSON.stringify(body),
        })
        .then((response) => status(response, postErrorAction))
        .then((response) => response.json())
        .then((response) => {
            postResultAction(response);
        })
        .catch(() => {
        });
}
function sendPatchRequest(Link, postResultAction, postErrorAction, body, customContentType, preSendManipulation){
    fetchWithAuth(Link, null,
        {
            method: 'PATCH', // *GET, POST, PUT, DELETE, etc.
            // mode: "cors", // no-cors, *cors, same-origin
            // cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            // credentials: "include", // include, *same-origin, omit
            headers: getAuthHeaders(customContentType, null), // Use getAuthHeaders
            body: preSendManipulation ? preSendManipulation(body) : JSON.stringify(body)
        })
        .then((response) => {
            return status(response, postErrorAction)
        })
        .then((response) => response.json())
        .then((response) => {
            postResultAction(response);
        })
        .catch(() => {
        });
}
function sendDeleteRequest(Link, signal, postResultAction, postErrorAction, customComapnyId){
    fetchWithAuth(Link, null,
        {
            signal: signal,
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            // mode: "cors", // no-cors, *cors, same-origin
            // cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            // credentials: "include", // include, *same-origin, omit
            headers: getAuthHeaders(null, customComapnyId), // Use getAuthHeaders
        })
        .then((response) => {
            return status(response, postErrorAction)
        })
        .then((response) => response.json())
        .then((response) => {
            postResultAction(response);
        })
        .catch(() => {
            
        });
}

// This function handles errors uniformly
// function handleRequestError(err, postErrorAction) {
//     if (err !== undefined && err.name === 'AbortError') {
//         // Handle abort signal case if necessary
//         return;
//     }

//     // Redirect to login if 401 Unauthorized
//     if (err && err.status === 401) {
//         localStorage.removeItem('access_token');
//         localStorage.removeItem('refresh_token');
//         window.location.href = '/login'; // Redirect to login page
//         return;
//     }

//     // Handle other errors
//     if (postErrorAction !== null) {
//         postErrorAction(err);
//     }
// }


export const uniquenessCheck = async (link, columnName, value, message, itemName, extraPayload)=>{
    link = encodeURI(link);
    return new Promise((resolve)=>{
        sendRequest(
            'POST',
            link,
            null,
            (result)=>{
                try {
                    if(result){
                        if(result.truckNumber && itemName){
                            resolve ('This '+ itemName+ ' already assigned to the truck #' + result.truckNumber)
                        }else if(result.driverName && itemName){
                            resolve ('This '+ itemName+ ' already assigned to ' + result.driverName)
                        }else{
                            resolve(message);
                        }
                    }
                } catch (error) {
                }
                resolve (null);
            },
            (e)=>{
                console.log(e);
                if(e!==null)console.log(e);
            },
            {
                ...extraPayload,
                "columnName": columnName,
                "value" : value
            }
        )
    })
}
function status(res, postErrorAction) {   
    if(!res.ok){
        res.json().then(
            (res)=>{
                postErrorAction(res);
            }
        ).catch((e)=>{
            if(postErrorAction){
                postErrorAction(res);
            }else{
                addNotification({message:`Something went wrong`, type:'alert'});
            }
            
        });
        throw new Error();
    }else if (res && res.status === 401) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login'; // Redirect to login page
        return;
    }
    return res;
}

// export function retreiveCompanyId(){
//     const companyId = ;
//     return 
// }